import styles from "./ManageCard.module.css";

const ManageCard = ({ heading, onClick }) => {
  return (
    <div className={styles.Wrapper} onClick={onClick}>
      <h2>{heading}</h2>
    </div>
  );
};

export default ManageCard;
